import { useContext } from 'react';
import {Flex, Stack} from '../../shared/layouts';
import Header from '../../shared/Header';
import { useQuery } from 'react-query';
import axios from 'axios';
import Loader from '../../shared/Loader';
import MessagebarContext from '../../../context/MessagebarContext';
import { useTranslation } from 'react-i18next';
import useIconLibrary from '../../../hooks/useIconLibrary';
import PlaceholderCard from "../../shared/PlaceholderCard";
import Card from "../../shared/Card";
import Button from "../../shared/Button";
import {useNavigate} from "react-router-dom";
import {useTheme} from '@emotion/react';
import {useMediaQuery} from "@dnhb/node_package";
import CalculationButton from "./components/CalculationButton";

const CalculationsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { breakpoints } = useTheme();
  const isMinTablet = useMediaQuery(
    `(min-width: ${breakpoints.tablet ?? '56.25rem'})`
  );
  const { setAlertMessage } = useContext(MessagebarContext);
  const { CalculationIcon } = useIconLibrary();

  const { isLoading, isFetchedAfterMount, data: calculationsList = [] } = useQuery(
    'calculations',
    async () => {
      try {
        const { data } = await axios('/calculations');
        return data?.data;
      } catch (error) {
        setAlertMessage();
      }
    }
  );

  return (
    <>
      {(isLoading || !isFetchedAfterMount) && <Loader />}
      <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
        <Header
          title={t('Mijn berekeningen')}
          icon={<CalculationIcon height="2rem" width="2rem" />}
          variant="page"
        />
        {calculationsList?.length === 0 ? (
          <PlaceholderCard
            title={t('Wat kan ik maximaal lenen?')}
            actionText={t('Start berekening')}
            actionUrl={'/tools/max-mortgage'}
          />
        ) : (
          <>
          <Card>
            <Stack space={'s'}>
              {calculationsList.map(({ id, name, output }) => (
                <CalculationButton
                  key={id}
                  name={name}
                  output={output}
                  onClick={() => navigate(`/tools/max-mortgage?calculationId=${id}`)}
                />
              ))}
            </Stack>
          </Card>
            <Flex justifyContent={'center'}>
            <Button
              variant={'primary-outline'}
              onClick={() => navigate('/tools/max-mortgage')}
              width={!isMinTablet ? '100%' : null}
            >
              {t('Maak nieuwe berekening')}
            </Button>
            </Flex>
          </>
          )}
      </Stack>
    </>
  );
};

export default CalculationsPage;
